<template>
  <div class="measurmentReport">
    <div class="measurmentReport__header">
      <div class="measurmentReport__header__title">
        <h1 class="medium-title">Measurement Report</h1>
      </div>
      <div class="measurmentReport__header__menu">
        <ul>
          <router-link tag="li" :to="{ name: 'traffic', query: { id: this.routeID, campaign_id: this.campaignID } }">Traffic</router-link>
          <router-link tag="li" :to="{ name: 'impact', query: { id: this.routeID, campaign_id: this.campaignID } }">Impact</router-link>
        </ul>
      </div>
    </div>
    <router-view/>
    <!-- Traffic -->
    <div class="trafficAdd">
      <div v-if="!isLoading" class="trafficAdd__content">
        <div class="trafficAdd__content--left">
          <!-- Campaign Detail -->
          <div class="trafficAdd__content__campaignDetail">
            <div class="header">
              <span class="subhead strong">Detail Report</span>
            </div>
            <div class="trafficAdd__content__campaignDetail__field">
              <adx-input v-if="routeID" type="text" :label="`Select Campaign`" :value.sync="campaignName" :disabled="true" />
            </div>
            <div class="trafficAdd__content__campaignDetail__field__date">
              <div :class="['calendar', inputDate == null && dateValidation ? 'warning' : '']">
                <label class="small-font">Select Date</label>
                  <v-date-picker
                    v-model="inputDate"
                    :min-date='convertDate(startdate)'
                    :max-date='convertDate(enddate)'
                    :popoverVisibility="'focus'"
                    :theme-styles='themeStyles'
                    :attributes='attributes'
                    class='date-input'>
                  <input class="calendar-start"
                    placeholder= "DD/MM/YYYY"
                    slot-scope='{ inputValue, updateValue }'
                    :value='inputValue'
                    :ref="'inputValue'"
                    type='text' 
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                </v-date-picker>
              </div>
              <div v-if="inputDate == null && dateValidation" class="error-message">Please select date</div>
            </div>
          </div>
          <!-- Traffic / Campaign -->
          <div class="trafficAdd__content__campaignDetail">
            <div class="header">
              <span class="subhead strong">Traffic / Campaign</span>
            </div>
            <div class="trafficAdd__content__campaignDetail__field">
              <adx-input :label="`Reach`" :value.sync="reportDetail.inputReach" :validation="['NotEmpty']" 
             :ref="dataRef.inputReach" :error.sync="error.inputReach" class="traffic"/>
              <adx-input :label="`Impression`" :value.sync="reportDetail.inputImpression" :validation="['NotEmpty']" 
            :ref="dataRef.inputImpression" :error.sync="error.inputImpression" class="traffic"/>
            <adx-input :disabled="true" :label="`Frequency`" :value.sync="reportDetail.frequency" :validation="['NotEmpty']" class="traffic"/>

            </div>
          </div>
          <!-- Impression / Locations -->
        <div class="trafficAdd__content__locations">
          <div class="header">
            <span class="subhead strong">Impression / Location</span>
          </div>
          <div class="locationsDetail" v-if="locations">
            <div class="trafficAdd__content__locations__input" v-for="(location, index) in locations" :key="index">
              <div class="trafficAdd__content__locations__field">
                <span class="subhead title">{{location.location_name}}</span>
                <adx-input :label="`Impression`" :value.sync="location.impression" :icon="`percent`" type="number" 
                :ref="dataRef.impression_location" :error.sync="error.impression_location" class="imppression"/>
              </div>

            </div>
            <div class="trafficAdd__content__locations__input" v-for="(location, index) in new_locations" :key="`new${index}`">
              <div class="trafficAdd__content__locations__field">
                <span class="subhead title">{{location.location_name}}</span>
                <adx-input :label="`Impression`" :value.sync="location.impression" 
                :icon="`percent`" class="imppression" type="number" :ref="dataRef.impression_location" :error.sync="error.impression_location"/>
              </div>
            </div>
          </div>
          <div v-if="locationsError" class="msg-error small-font">Total percentage must be 100%</div>
        </div>
        <div class="trafficAdd__content__buttons">
          <button class="btn-regular secondary btn"  @click="editCampaign()">Edit Campaign</button>
          <button class="btn-large primary" @click="save">Save</button>
        </div>
      </div>
    </div>
    <div v-else><adx-loading slot="loading"/></div>
  </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import TextArea from '@/components/Form/TextArea'
import Dropdown from '@/components/Form/SelectDropdown'
import LoadingSpinner from '@/components/Loading/Secondary-white'
import Loading from '@/components/Loading/Primary'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'


import api from '@/api'
import moment from 'moment';
import calendar from 'v-calendar'
import { apiV2 } from '@/api/urls'
import triggerValidation from '@/lib/triggerValidation'


export default {
  name: 'adx-traffic',
  components: {
    'adx-input': Input,
    'adx-textarea': TextArea,
    'adx-dropdown': Dropdown,
    'adx-loading-white': LoadingSpinner,
    'adx-loading': Loading,
    'adx-single-search-dropdown': SingleSearchDropdown,
  },
  props: {
  },
  data() {
    return {
      campaignName: null,
      startdate: null,
      enddate: null,
      currentCampaign: null,
      isLoading: false,
      routeID: null,
      isLoadingData: false,
      validation: true,
      campaignID: null,
      total: 0,
      date: null,
      campaignInputted: true,
      dateInputted: true,
      dataEmpty: false,
      isDateEmpty: true,
      locationsError: false,
      dateValidation:'',
      locations: [],
      new_locations: [],
      reportDetail: {
        dropdownCampaignID: null,
        id: null,
        inputReach: null,
        inputImpression: null,
        frequency: 0
      },
      error: {
      dropdownCampaignID: null,
      date: null,
      impression_location: null,
      inputReach: null,
      inputImpression: null,
      },
      dataRef: {
        inputReach: 'inputReach',
        inputImpression: 'inputImpression',
      },
      campaignOptions: [],
      inputDate: null,
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ]
    }
  },
  computed: {
  },
  watch: {
    'reportDetail.campaignID': function () {
      this.getData()
    },
    'reportDetail.inputImpression':function () {
      this.calculateFreq()
    },
    'reportDetail.inputReach':function () {
      this.calculateFreq()
    },
    'campaignID': function () {
      this.error.campaignID = null
    },
    campaignID: function () {
      this.getInputedDate()
      if (this.inputDate) {
        this.getInputedData()
      }
    },
    inputDate: function () {
      if (this.campaignID != null) {
        this.getInputedData()
      }
    },
    locations: {
      handler: function () {
        this.validateImpressions()
      },
      deep : true
    },
    new_locations: {
      handler: function () {
        this.validateImpressions()
      },
      deep : true
    },
  },
  beforeCreate() {

  },
  created() {
    this.getCampaignList()

  },
  beforeMount() {
    
  },
  mounted() {
    if(this.$route.query.id){
      this.routeID = this.$route.query.id
    }
    if(this.$route.query.campaign_id){
      this.campaignID = this.$route.query.campaign_id
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    convertDate(value) {
      return new Date(value)
    },
    today() {
      let today = new Date();
      today.setDate(today.getDate() - 1)
      return today
    },
    calculateFreq(){
      if ( this.reportDetail.inputImpression == null && this.reportDetail.inputReach == null){
        this.reportDetail.frequency = 0
      } else if (this.reportDetail.inputImpression != 0 && this.reportDetail.inputReach != 0 ){
        this.reportDetail.frequency = (this.reportDetail.inputImpression/this.reportDetail.inputReach).toFixed(2)
      } else if (this.reportDetail){
        this.reportDetail.frequency = 0
      } else{
        this.reportDetail.frequency = 0
      }
    },
    validateImpressions() {
      let allInterest = []
      let total = 0
      allInterest = this.locations.concat(this.new_locations)
      allInterest.map(location => {
        total += parseInt(location.impression)
      })
      this.total = total
      total == 100 || total == 0 ? this.locationsError = false : this.locationsError = true 
    },
    getData (){
      (async () => {
        const { data } = await api.get(apiV2.measurementGetLocations(this.reportDetail.campaignID), { needToken: true })
        data.locations.map(list => {
          this.listing.push({
            label: list.location_name,
            value: list.location_inside
          })
        })
      })();
    },
    getInputedData() {
      (async () => {
        this.isLoadingData = true
        let convertedDate = moment(this.inputDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')
        const params = {
          date: convertedDate,
          campaign: this.campaignID
        }
        const response = await api.get(apiV2.measurementcampaignReportAdd, { params: params, needToken: true })
        if (response.status == 200) {
          const { data } = response
          this.locations=[]
          if (!data.id) {
            this.dataEmpty = true
            this.id = null
            this.assignLocations(data.locations)
            this.assignCampaignTraffic(data)
            this.resetTraffic()

          } else {
            this.dataEmpty = false
            this.id = data.id
            this.assignLocations(data.locations)
            this.assignCampaignTraffic(data)
          }
        }
        this.isLoadingData = false
      })();
    },
    getInputedDate() {
      (async () => {
        this.isLoadingData = true
        this.attributes[0].dates = []
        let params = this.campaignID
        
        const response = await api.get(apiV2.measurementGetDate(params), {needToken: true })
        if (response.status == 200) {
          const date  = response.data.date
          const start = response.data.start
          const end  = response.data.end

          this.startdate = new Date(start)
          let endcampaigndate = new Date(end)
          let today = this.today()
          if (endcampaigndate > today){
            this.enddate = today
          } else{
            this.enddate = end
          }
          date.map(obj => {
            this.attributes[0].dates.push(obj)
          })
        }
        this.isLoadingData = false
      })();
    },
    assignLocations(data){
      data.forEach((location) => {
        this.locations.push({
          location_name: `${location.location_name}`,
          type_id: location.type_id,
          id: location.id,
          impression: Math.round(location.impression * 100 * 100)/100
        });
      })
    },
    assignCampaignTraffic(data){
      this.reportDetail.id= data.id || null
      this.reportDetail.inputReach = data.traffic
      this.reportDetail.inputImpression = data.impression
    },
    save() {
      const data = {
        campaignID: this.campaignID,
        report_detail: this.reportDetail.id,
        date: this.convertedDate,
        impression: this.locations,
        traffic_reach: this.reportDetail.inputReach,
        traffic_impression: this.reportDetail.inputImpression,
      }
      let validation = this.inputValidation(data)
      let isValid = triggerValidation(this.reportDetail, this.dataRef, this.$refs, this.error)
      this.dateValidation = this.date_Validate()
      if ( validation.isValid && isValid) {
        (async () => {
          let convertedDate = moment(this.inputDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')
          if (this.dataEmpty) {
            let locationmap = this.locations.map(loc =>{
                let data = {}
                data.id = loc.id
                data.type_id = loc.type_id
                data.impression = loc.impression? loc.impression /100 : 0
                data.location_name = loc.location_name

                return data
            })
            let data = {
                'campaign_detail': {
                  'id': this.campaignID,
                  'date':convertedDate
              },
                'locations': locationmap,
                
                'audience': {
                  'traffic': this.reportDetail.inputReach,
                  'impression': this.reportDetail.inputImpression
              }
            }
            const response = await api.post(apiV2.measurementcampaignReportAdd, data, { needToken: true })
            if (response.status == 201) {
              this.$notify({
                group: 'saved',
                title: 'Save success',
                text: 'Data successfully saved!',
                type: 'success'
              });
              this.getInputedDate()
            } else{
              this.$notify({
                group: 'saved',
                title: 'Save error',
                text: 'Oops data can not be saved!',
                type: 'danger'
              });
            }
          } else{
            let locationmap = this.locations.map(loc =>{
                let data = {}
                data.id = loc.id
                data.type_id = loc.type_id
                data.impression = loc.impression ? loc.impression /100 : 0
                data.location_name = loc.location_name

                return data
            })
            let data = {
                'campaign_detail': {
                'id': this.reportDetail.id,
                'date':convertedDate
              },
                'locations': locationmap,
                'audience': {
                'traffic': this.reportDetail.inputReach,
                'impression': this.reportDetail.inputImpression 
              }
            }
            const response = await api.put(apiV2.measurementcampaignReportDetailEditPost, data, { needToken: true })
            this.isLoadingSubmit = false
            if (response.status == 201) {
              this.$notify({
                group: 'saved',
                title: 'Save success',
                text: 'Data successfully saved!',
                type: 'success'
              });
            }else{
              this.$notify({
                group: 'saved',
                title: 'Save error',
                text: 'Oops data can not be saved!',
                type: 'danger'
                });
            }
          }
        })();
      } else if(isValid){ 
        this.raiseError(validation.errorMessage)
      } else{
        this.$notify({
                group: 'saved',
                title: 'Save error',
                text: 'Oops data can not be saved!',
                type: 'danger'
                });
      }
    },
    inputValidation(input) {
      let data = { isValid: true, errorMessage: null }
      let isValid = true
      if(parseInt(this.total )!= 100){
        data.isValid = false
        data.errorMessage = "Total percentage must be 100%"
        isValid = false
      }
      return data
    },
    raiseError(errorMessage) { 
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: errorMessage,
        type: 'danger'
      });
    },
    date_Validate(){
      let isDateEmpty = true
      if (this.$refs.inputValue.value) {
        isDateEmpty = false
      }
      return isDateEmpty
    },
    editCampaign() {
        this.$router.push({ name: 'addnew', query: { id: this.routeID } })
    },
    getCampaignList() {
      (async () => {
        const { status, data } = await api.get(apiV2.measurementgetCampaignName, { needToken: true })
        this.campaignName = data.filter(list => list.id == this.campaignID).pop().title
        
      })();
    },
    getDropdownOptions() {
      this.getCampaignList()
    },
    resetTraffic() {
      this.reportDetail.inputReach = null
      this.reportDetail.inputImpression = null
      this.reportDetail.id= null
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>